/**
 * Do not edit directly
 * Generated on Wed, 06 Dec 2023 14:15:34 GMT
 */
export const theme = {
    color: {
        white: 'rgba(255,255,255,1)',
        black: 'rgba(0,0,0,1)',
        transparent: 'rgba(255,255,255,0)',
        turquoise50: 'rgba(16,199,209,1)',
        turquoise70: 'rgba(12,159,167,1)',
        turquoise90: 'rgba(10,127,133,1)',
        teal10: 'rgba(231,244,242,1)',
        teal50: 'rgba(60,195,178,1)',
        teal70: 'rgba(49,160,145,1)',
        red10: 'rgba(229,5,0,0.14901960784313725)',
        red30: 'rgba(234,85,77,1)',
        red50: 'rgba(229,5,0,1)',
        red70: 'rgba(209,10,0,1)',
        red90: 'rgba(154,11,4,1)',
        orange50: 'rgba(247,138,49,1)',
        orange70: 'rgba(231,109,8,1)',
        orange90: 'rgba(186,85,2,1)',
        yellow10: 'rgba(247,182,0,0.14901960784313725)',
        yellow50: 'rgba(247,182,0,1)',
        yellow90: 'rgba(145,66,1,1)',
        green10: 'rgba(174,205,67,0.14901960784313725)',
        green30: 'rgba(221,221,109,1)',
        green50: 'rgba(174,205,67,1)',
        green70: 'rgba(102,153,0,1)',
        green90: 'rgba(0,128,0,1)',
        blue10: 'rgba(0,154,219,0.14901960784313725)',
        blue50: 'rgba(0,154,219,1)',
        blue70: 'rgba(0,119,170,1)',
        blue90: 'rgba(0,89,128,1)',
        purple10: 'rgba(128,76,245,0.10196078431372549)',
        purple50: 'rgba(187,94,197,1)',
        purple70: 'rgba(153,59,163,1)',
        purple90: 'rgba(112,43,120,1)',
        neutral10: 'rgba(249,249,249,1)',
        neutral20: 'rgba(244,244,244,1)',
        neutral30: 'rgba(238,238,238,1)',
        neutral40: 'rgba(220,220,220,1)',
        neutral50: 'rgba(191,191,191,1)',
        neutral60: 'rgba(140,140,140,1)',
        neutral70: 'rgba(117,117,117,1)',
        neutral80: 'rgba(102,102,102,1)',
        neutral90: 'rgba(54,58,57,1)',
        neutral100: 'rgba(41,41,41,1)',
        brandMidnightBlue: 'rgba(10,0,79,1)',
        brandPurple: 'rgba(128,76,245,1)',
    },
    shadow: {
        topLt: '0px -24px 24px #29292933',
        topMd: '0px -24px 24px #29292966',
        leftMd: '-8px 0px 24px #29292966',
        leftLt: '-8px 0px 24px #29292933',
        rightMd: '8px 0px 24px #29292966',
        rightLt: '8px 0px 24px #29292933',
        md: '0px 4px 8px #29292966',
        lt: '0px 2px 4px #29292933',
    },
    spacing: {
        px4: '4px',
        px8: '8px',
        px12: '12px',
        px16: '16px',
        px24: '24px',
        px32: '32px',
        px40: '40px',
        px48: '48px',
        px64: '64px',
        px80: '80px',
        px96: '96px',
        px160: '160px',
    },
    font: {
        hero: {
            font: 'normal 400 48px/56px Roboto Condensed',
            textTransform: 'none',
        },
        titleH1: {
            font: 'normal 700 32px/38px Roboto Condensed',
            textTransform: 'none',
        },
        titleH2: {
            font: 'normal 400 28px/33px Roboto Condensed',
            textTransform: 'none',
        },
        titleH3: {
            font: 'normal 700 24px/36px Roboto',
            textTransform: 'none',
        },
        titleH4: {
            font: 'normal 400 20px/23px Roboto Condensed',
            textTransform: 'uppercase',
        },
        titleH5: {
            font: 'normal 700 20px/23px Roboto',
            textTransform: 'none',
        },
        titleH6: {
            font: 'normal 400 20px/30px Lato',
            textTransform: 'none',
        },
        body: {
            font: 'normal 400 16px/24px Lato',
            textTransform: 'none',
        },
        bodyItalic: {
            font: 'italic 400 16px/24px Lato',
            textTransform: 'none',
        },
        bodyStrong: {
            font: 'normal 700 16px/24px Lato',
            textTransform: 'none',
        },
        metadata: {
            font: 'normal 400 12px/21px Lato',
            textTransform: 'none',
        },
        metadataStrong: {
            font: 'normal 700 12px/21px Lato',
            textTransform: 'none',
        },
        label: {
            font: 'normal 400 16px/19px Roboto Condensed',
            textTransform: 'none',
        },
        labelStrong: {
            font: 'normal 700 16px/19px Roboto Condensed',
            textTransform: 'uppercase',
        },
        labelSm: {
            font: 'normal 400 12px/14px Roboto Condensed',
            textTransform: 'uppercase',
        },
        labelSmStrong: {
            font: 'normal 700 12px/14px Roboto Condensed',
            textTransform: 'uppercase',
        },
        metricXl: {
            font: 'normal 700 72px/84px Lato',
            textTransform: 'none',
        },
        metricLg: {
            font: 'normal 700 48px/56px Lato',
            textTransform: 'none',
        },
        metricMd: {
            font: 'normal 700 40px/47px Lato',
            textTransform: 'none',
        },
        metricSm: {
            font: 'normal 700 32px/38px Lato',
            textTransform: 'none',
        },
        metricXs: {
            font: 'normal 700 20px/23px Lato',
            textTransform: 'none',
        },
        mono: {
            font: 'normal 400 16px/24px Source Code Pro',
            textTransform: 'none',
        },
        monoStrong: {
            font: 'normal 700 16px/24px Source Code Pro',
            textTransform: 'none',
        },
    },
    zIndex: {
        sunk: -9999,
        default: 1,
        sticky: 100,
        dialog: 1000,
        modal: 2000,
        popover: 4000,
        dropdown: 4500,
        tooltip: 4500,
        toast: 5000,
    },
};
